export default {
  views: {
    product: {
      description:
        '도쿄 스카이트리 관람권과 도쿄 소라마치에 설치된 수미다 수족관 관람권이 세트로 제공되는 저렴한 티켓입니다.',
      plans: {
        title: '플랜 선택'
      },
      cancelPolicy: {
        title: '취소 정책'
      },
      panels: {
        selectDate: '날짜 선택',
        selectPlan: '플랜 선택',
        selectPeople: '인원 선택',
        options: '옵션',
        profile: '프로필'
      },
      auth: {
        loginOrRegister: '로그인 / 회원가입',
        signUpTip: '정보를 입력하여 회원가입하세요'
      },
      calendar: {
        priceNote: '※표시 가격은 당일 성인 요금입니다'
      },
      recommendations: {
        title: '추천 상품'
      }
    },
    book: {
      title: '예약 확인',
      bookingNotice: '예약 전 확인',
      paymentConfirmation: '결제 전 확인',
      tip: '예약을 확정하기 위해 가능한 한 신속히 결제를 완료해 주시기 바랍니다.'
    },
    bookConfirm: {
      paymentInfo: '결제 정보',
      paymentConfirmation: {
        warningTitle: '취소 정책을 확인하세요:',
        warningText: '구매 후 반환할 수 없습니다.',
        agreementText: '위의 내용을 확인하였고, 동의합니다.'
      },
      prePaymentConfirmation: {
        title: '결제 전 확인 사항',
        checkInput: '입력 내용이 올바른지 확인해 주세요.',
        emailNotice:
          '주의: 스팸 메일 차단을 위해 도메인 지정 수신 설정을 하신 경우, 예약 전 "@linktivity.co.jp" 도메인을 등록해 주세요.',
        agreementText: '위 사항을 확인하고 동의합니다.'
      },
      paymentAmount: {
        total: '결제 금액 (세금 포함)',
        details: '상세',
        note: '일본 엔화 이외의 통화로 표시되는 금액은 현재 환율을 기준으로 한 추정값이며, 실제 청구 금액과 다를 수 있습니다. 참고용으로 확인해 주시기 바랍니다.'
      },
      participantInfo: {
        title: '대표자 정보',
        dialogTitle: '대표자 정보 변경',
        change: '변경',
        password: '비밀번호',
        validation: {
          passwordRequired: '비밀번호를 입력해 주세요'
        }
      },
      actionButtons: {
        back: '이전',
        toPayment: '결제로'
      }
    },
    voucher: {
      pdf: '출력용 PDF',
      html: '바우처'
    },
    bookingDetail: {
      title: '예약 상세',
      detailInfo: '예약 상세',
      startDate: '참가 일시',
      validityPeriod: '유효 기간',
      voucherInfo: '바우처',
      digitalTicket: '전자 티켓',
      invoice: '영수증·송장',
      invoiceSend: '발행',
      invoiceSent: '송장 발행 완료',
      redemption: 'E-티켓 사용',
      meetingPoint: '입장 위치 안내',
      beforeTrip: '이용 전 확인 사항',
      bookingAction: '예약 관리',
      cancelBooking: '예약 취소',
      cancelConfirmPolicy: '취소 정책을 확인해 주세요:',
      customerName: '예약자명',
      actualPayment: '결제 금액',
      refundAmount: '환불 금액',
      orderId: '예약 ID',
      orderCompletionTime: '예약 시간',
      digitalTicketValidPeriod: 'QR 코드는 이용 당일에만 유효합니다',
      digitalTicketWaiting: '*주문 확인 후 전자 티켓이 여기에 표시됩니다',
      sending: '전송 중...',
      sendToEmail: '이메일로 전송',
      cancelConfirm: '예약을 취소하시겠습니까?',
      cancelFee: '취소 수수료',
      cancelRemarkSelect: '취소 사유를 선택해 주세요',
      inclusion: '포함된 물품',
      checklist: '주의사항',
      restrictions: '참가 제한',
      requirements: '참가 전 및 참가 중 필요 사항',
      attireItems: '참가 시 필요 의복 및 소지품',
      otherInfo: '비고·기타',
      attachmentType: {
        ATTACHMENT_TYPE_PDF: 'PDF',
        ATTACHMENT_TYPE_IMAGE: 'Image'
      }
    },
    cancelReason: {
      CANCEL_REASON_OTHER: '기타',
      CANCEL_REASON_MODIFY_BOOKING: '예약 내용을 변경하고 싶어요',
      CANCEL_REASON_BOOKED_BY_MISTAKE: '잘못 예약함',
      CANCEL_REASON_DUPLICATE_BOOKING: '중복 예약이라서',
      CANCEL_REASON_HEALTH_CONDITION: '질병',
      CANCEL_REASON_TRANSPORTATION_ISSUE: '항공편 취소·지연·변경',
      CANCEL_REASON_SCHEDULE_CONFLICT: '일정 충돌',
      CANCEL_REASON_CHANGE_TO_OTHER_PRODUCT: '다른 상품으로 변경'
    },
    common: {
      withDashSeparated: '{{val1}} - {{val2}}'
    },
    components: {
      selectOption: {
        title: '옵션',
        quantity: '수량: {{quantity}}',
        addCart: '장바구니에 추가',
        timeSelect: '시간을 선택',
        quantitySelect: '수량을 선택',
        quantitySelectLabel: '수량',
        soldOut: '품절',
        total: '합계'
      },
      planCard: {
        tip: '당일권 판매 예정'
      },
      planDetailDialog: {
        title: '플랜 상세',
        planContent: '플랜 내용',
        meetingPlace: '집합 장소',
        cancellationPolicy: '취소 정책'
      },
      priceTableDialog: {
        notes: {
          agePolicy: `5세 이하는 무료, 6세인 경우 미취학이면 무료입니다. 15세인 경우 중학생이면 어린이 요금, 고등학생인 경우 성인 요금을 적용합니다.`
        }
      },
      payment: {
        ticket: '티켓',
        option: '옵션',
        total: '합계 (세액 포함)',
        details: '상세',
        submit: '주문하기'
      },
      bookingInfo: {
        plan: '플랜',
        dateTime: '날짜 및 시간',
        ticket: '티켓',
        option: '옵션',
        discount: '할인',
        total: '결제 금액 (세액 포함)'
      }
    },
    home: {
      title: '도쿄 스카이트리',
      header: {
        alt: '도쿄 스카이트리'
      },
      search: {
        placeholder: '상품 검색'
      },
      ticketList: {
        title: '티켓 목록'
      },
      enjoyPack: {
        title: '엔조이 팩'
      }
    },
    faq: {
      title: '자주 묻는 질문',
      purchase: {
        title: '티켓 구매',
        q1: '신용카드로 결제가 되지 않을 경우 어떻게 해야 하나요?',
        a1: `결제 화면이 마지막 단계까지 진행되지 않는 경우, 아래 사항을 확인해 주시기 바랍니다.

1） 통신 상태
・일시적으로 통신 환경이 불안정하여 결제가 중단되었을 가능성이 있습니다.
한 번 화면을 닫은 후, 잠시 기다렸다가 통신 상태가 좋은 곳에서 처음부터 다시 결제를 시도해 주시기 바랍니다.

2） 카드 이용 상태 및 3D Secure 관련 사항
・이용 중인 신용카드의 유효기간 및 이용 한도에 문제가 없는지 확인해 주시기 바랍니다.
・이용 중인 신용카드가 ‘3D Secure’를 지원하는지 확인해 주시기 바랍니다.
2025년 4월부터 온라인 구매 시 신용카드 ‘3D Secure’ 도입이 의무화됨에 따라,
도쿄 스카이트리 예약 사이트에서는 ‘3D Secure’가 설정된 카드로만 결제가 가능합니다.

3） 카드사의 보안 시스템
카드에 문제가 없음에도 결제가 되지 않는 경우, 카드사의 보안 시스템이 작동하여 결제가 중단되었을 가능성도 있습니다.
이 경우 이용 중인 카드사로 문의해 주시기 바랍니다.

・결제 상황에 대해 자세한 확인을 원하시는 경우에는 아래 문의 양식을 통해 문의해 주시기 바랍니다. 
https://veltra.zendesk.com/hc/ko/requests/new?ticket_form_id=53455569113241`,
        q2: '희망 날짜와 시간이 달력에서 ×로 표시되는 이유는 무엇인가요?',
        a2: `＜도쿄 스카이트리 전망대·전망 회랑 입장권＞
・입장권은 이용일 기준 2개월 전부터 판매가 시작되며, 캘린더가 순차적으로 오픈됩니다.
・판매 시작 후 구매 페이지의 캘린더에서 희망 날짜나 시간대를 클릭할 수 없는 경우, 해당 티켓은 매진된 상태입니다.
희망하시는 날짜나 시간대에 빈자리가 없는 경우에는 전후 날짜 및 시간대도 함께 검토해 주시기 바랍니다.
▼판매 페이지 바로가기
https://global-official-ticket.tokyo-skytree.jp/ko/home

※온라인 구매는 당일까지 가능하나, 대형 연휴 기간 등에는 조기에 매진될 수 있습니다.
※온라인 구매 티켓은 당일 현장 창구 판매보다 더 저렴한 가격으로 제공되므로, 사전 구매를 권장드립니다.

＜스카이트리 엔조이팩＞
・엔조이팩은 이용일 기준 1개월 전부터 판매가 시작되며, 이용 희망일 전날까지 구매하실 수 있습니다(당일 판매는 없습니다)`,
        q3: '티켓 판매는 언제부터 시작되나요?',
        a3: `＜도쿄 스카이트리 전망대・전망 회랑 입장권＞
・입장권은 2개월 전부터 판매가 시작되며, 캘린더가 순차적으로 오픈됩니다.
・온라인 구매는 방문 당일까지 가능하나, 연휴 등의 시기에는 조기에 매진될 수 있습니다.

＜스카이트리 엔조이팩＞
・엔조이팩은 1개월 전부터 판매가 시작됩니다. 이용 희망일 전날까지 구매하실 수 있습니다（당일 판매는 없습니다）

※스미다강 불꽃놀이나 새해 첫날 등 특별 영업시간대의 티켓은 판매 시작 시기가 다릅니다. 자세한 사항은 해당 시기가 가까워지면 도쿄 스카이트리 공식 사이트에서 안내됩니다.`,
        q4: '온라인 구매 시 어떤 결제 방법을 이용할 수 있나요?',
        a4: `신용카드(VISA, MASTER, AMEX,JCB,DINERS), 직불카드, Alipay, Wechatpay를 이용하실 수 있습니다.`,
        q5: '당일권이 있다면 현장에서 구매할 수 있나요?',
        a5: `＜도쿄 스카이트리 전망대・전망 회랑 입장권＞
・당일권 전용 수량은 별도로 준비되어 있지 않습니다.
모든 티켓은 사전 판매로 안내되고 있으며 사전 단계에서 재고가 남아 있는 날짜와 시간에 한해 당일에도 구매하실 수 있습니다. 
이미 매진된 날짜와 시간의 티켓은 당일 추가 판매가 진행되지 않습니다.
・온라인 판매와 현장 발권기 모두 당일 재고가 남아 있는 경우에만 구매가 가능합니다. 사전에 매진된 날짜와 시간의 티켓은 당일 추가 판매가 없습니다.
・연휴 기간 등에는 조기에 매진될 수 있습니다.
・온라인으로 구매한 티켓은 당일 현장 창구 판매보다 더 저렴한 가격으로 제공되므로 사전 구매를 권장드립니다.
・최신 판매 현황은 아래 판매 페이지에서 확인해 주시기 바랍니다.

▼판매 페이지
https://global-official-ticket.tokyo-skytree.jp/ko/home

＜스카이트리 엔조이팩＞
・엔조이팩은 당일 판매는 없습니다. 이용 희망일 전날까지 구매해 주시기 바랍니다.`,
        q6: '중학교를 졸업하고 고등학교 입학 전인 학생은 어떤 티켓을 구매해야 하나요?',
        a6: `입장일 기준 만 15세까지는 소인, 만 16세 이상은 성인 요금이 적용됩니다.`,
        q7: '회원 등록은 필수인가요?',
        a7: `도쿄 스카이트리 티켓 구매 시에는 회원 등록이 필요합니다.
로그인이 되지 않는 경우에는, 아래 페이지를 참고해 주시기 바랍니다.

▼ 로그인할 수 없는 경우
FAQ의 「로그인할 수 없습니다.」 항목을 참고해 주시기 바랍니다.`,
        q8: '엔조이팩에 장애인 할인이 적용되나요?',
        a8: `엔조이팩은 이미 할인 가격이 적용된 특가 상품이므로, 추가로 장애인 할인은 적용되지 않습니다.`,
        q9: '도쿄 스카이트리 시설 내에서 쇼핑이나 식사 및 주차장 이용이 가능한가요?',
        a9: `시설・설비, 주차장, 단체 예약, 단체 전용 주차장에 대한 자세한 사항은, 도쿄 스카이트리 공식 사이트의 「문의하기」 페이지에서 「자주 묻는 질문」을 확인해 주시기 바랍니다.
▼도쿄 스카이트리 공식 사이트 시설・설비 관련 문의는 아래에서 확인해 주시기 바랍니다
https://www.tokyo-skytree.jp/inquiry/faq.html

▼도쿄 스카이트리 공식 사이트 단체 예약 관련 페이지는 아래에서 확인해 주시기 바랍니다
https://www.tokyo-skytree.jp/ticket/group/general/`
      },
      late: {
        title: '입장 시간에 늦을 것 같은 경우',
        q1: '예약 시간에 늦을 것 같습니다.',
        a1: `원칙적으로는 구매 시 지정하신 시간대에 입장해 주시기 바랍니다.
다만, 부득이한 사정으로 지정 시간에 늦을 경우에는, 날짜 지정권을 소지한 고객에 한하여 지정일 당일에만 안내 중인 대기열의 마지막에서 입장하실 수 있습니다.
순차적으로 안내해 드리나, 혼잡 상황에 따라 대기 시간이 발생할 수 있습니다.
당일 영업시간은 도쿄 스카이트리 공식 사이트에서 확인해 주시기 바랍니다.
▼영업시간 캘린더
https://www.tokyo-skytree.jp/open-hours/`
      },
      conditions: {
        title: '전망 및 혼잡',
        q1: '당일 전망에 대하여',
        a1: `전망은 시간대에 따라 달라지므로 콜센터로 문의하셔도 안내해 드리기 어려운 점 양해 부탁드립니다. 도쿄 지역의 기상 정보를 참고해 주시기 바랍니다.
우천이나 흐린 날씨로 인해 시야 확보가 불량한 경우에도 환불 또는 부분 할인은 불가합니다.
취소를 원하시는 경우에는 마이페이지에서 취소 정책 및 취소 수수료를 확인하신 후 절차를 진행해 주시기 바랍니다.

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking`,
        q2: '당일 혼잡 상황에 대하여',
        a2: `도쿄 스카이트리 공식 사이트 메인 페이지에 혼잡 정도를 안내하고 있으니 참고해 주시기 바랍니다.
・혼잡 상황에 따라 엘리베이터 대기 시간이 발생할 수 있으나, 콜센터로 문의하셔도 대기 시간 안내는 어려운 점 양해 부탁드립니다. 여유 있게 방문해 주시기 바랍니다.
・전망대 입장 후 체류 시간 제한은 없으나, 드물게 당일 혼잡 상황이나 엘리베이터 운행 상황에 따라 부득이하게 직원이 안내를 드릴 수 있습니다.
▼도쿄 스카이트리 공식 사이트
https://www.tokyo-skytree.jp/kr/ticket/congestion/`,
        q3: '예약 완료 메일이 도착하지 않습니다.',
        a3: `예약 시 등록하신 이메일 주소로 「예약이 확정 처리 되었습니다（예약 번호: ARS_SKYTREE-XXXX-XXXX)」라는 제목의 자동 메일을 발송하고 있으니 확인해 주시기 바랍니다.
・예약 확정 메일은 「@linktivity.co.jp」 도메인에서 발송됩니다.
・스팸 메일함 및 휴지통 폴더도 확인해 주시기 바랍니다.
・평소 자주 사용하지 않는 이메일 주소로 등록하셨을 가능성이 있습니다.
다른 가능성이 있는 이메일 주소의 수신함도 함께 확인해 주시기 바랍니다.

메일을 찾을 수 없는 경우에는 마이페이지에 로그인하여 예약 현황을 확인해 주시기 바랍니다.
▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

＊도쿄 스카이트리 공식 사이트 이외의 온라인 여행사에서 구매하신 경우에는 구매하신 여행사로 문의해 주시기 바랍니다.

▼ 로그인할 수 없는 경우
FAQ의 「계정에 로그인할 수 없을 때 어떻게 해야 하나요?」 항목을 참고해 주시기 바랍니다.`,
        q4: '결제가 완료되었는데, 티켓을 찾을 수 없습니다.',
        a4: `당일 필요한 티켓 QR코드가 포함된 바우처는 마이페이지 또는 예약 확정 메일에서 확인하실 수 있습니다.

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

▼예약 확정 메일에 대하여
・예약 확정 메일은 「@linktivity.co.jp」 도메인에서 발송됩니다.
・스팸 메일함 및 휴지통 폴더도 확인해 주시기 바랍니다.
・평소 자주 사용하지 않는 이메일 주소로 등록하셨을 가능성이 있습니다.
다른 가능성이 있는 이메일 주소의 수신함도 함께 확인해 주시기 바랍니다.

▼ 로그인할 수 없는 경우
FAQ의 「로그인할 수 없습니다.」 항목을 참고해 주시기 바랍니다.

＊도쿄 스카이트리 공식 사이트 이외의 온라인 여행사에서 구매하신 경우에는 구매하신 여행사로 문의해 주시기 바랍니다.`,
        q5: 'QR코드가 스마트폰 화면에 표시되지 않습니다.',
        a5: `당일 필요한 티켓 QR코드가 포함된 바우처는 마이페이지 또는 예약 확정 메일에서 확인하실 수 있습니다.

모바일 기기 화면에서 QR코드가 제대로 표시되지 않는 경우에는, 한 번 화면을 닫고, 인터넷 접속 상태가 좋은 곳에서 다시 시도해 주시기 바랍니다.
입장에는 QR코드가 필요하므로, 사전에 화면에 표시되는지 확인하시고 스크린샷을 촬영해 두시는 것도 권장드립니다.

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

▼ 로그인할 수 없는 경우
FAQ의 「로그인할 수 없습니다.」 항목을 참고해 주시기 바랍니다.

＊도쿄 스카이트리 공식 사이트 이외의 온라인 여행사에서 구매하신 경우에는 구매하신 여행사로 문의해 주시기 바랍니다.`,
        q6: '로그인할 수 없습니다.',
        a6: `1）먼저, 올바른 이메일 주소로 로그인하고 있는지 확인해 주시기 바랍니다.
평소 자주 사용하지 않는 이메일 주소로 등록하셨을 가능성이 있으므로, 가능성이 있는 다른 이메일 주소로도 로그인을 시도해 주시기 바랍니다.

2）신규 회원 등록 시와 동일한 로그인 방법을 이용해 주시기 바랍니다.
Gmail을 이용하시는 경우에는 신규 등록 시 「Google」 버튼을 통해 Google 연동을 선택하여 등록했는지, 또는 「이메일」 버튼을 통해 직접 이메일 주소를 입력하여 등록했는지 확인해 주시기 바랍니다.
비밀번호를 잊으신 경우에는 로그인 화면의 「비밀번호를 잊으신 경우」에서 비밀번호 재설정을 진행해 주시기 바랍니다.

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

＊도쿄 스카이트리 공식 사이트 이외의 온라인 여행사에서 구매하신 경우에는 구매하신 여행사로 문의해 주시기 바랍니다.`,
        q7: '예약 완료 메일을 삭제했습니다. 어떻게 해야 하나요?',
        a7: `다음 중 하나의 방법으로 바우처・QR코드를 표시하실 수 있습니다.

1）마이페이지에서 예약 확인
로그인 → 오른쪽 상단 사람 모양 아이콘  「마이페이지」 → 「예약 정보」 → 예약 목록 표시 → 예약 상세 화면에서 바우처 표시

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

2）마이페이지에서 메일 재발송
로그인 → 오른쪽 상단 사람 모양 아이콘 「마이페이지」 → 「예약 정보」 → 예약 목록 표시 → 예약 상세 화면의 「바우처 보내기」 버튼을 통해 원하는 주소로 티켓 URL이 포함된 바우처 재발송

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

＊도쿄 스카이트리 공식 사이트 이외의 온라인 여행사에서 구매하신 경우에는 구매하신 여행사로 문의해 주시기 바랍니다.`,
        q8: '계정을 삭제하여 마이페이지에 로그인할 수 없습니다. 티켓은 이용할 수 있나요?',
        a8: `예약을 취소하지 않은 한, 예약（티켓） 자체는 유효하므로 이용하실 수 있습니다.
예약 확정 메일에서 티켓 URL이 포함된 바우처를 표시하실 수 있습니다.

*QR코드는 주식회사 덴소웨이브의 등록상표입니다.`,
        q9: '바우처를 인쇄하여 지참해도 되나요?',
        a9: `QR코드는 종이에 출력한 것도 이용하실 수 있습니다. 스크린샷, 모바일 기기 화면 표시로도 이용하실 수 있습니다.
인쇄하실 경우에는 QR코드가 선명하게 출력된 것을 지참해 주시기 바랍니다.`,
        q10: '전망대 입장 후 체류 시간 제한이 있나요?',
        a10: `입장 후에는 체류 시간에 제한이 없습니다.`,
        q11: '사전에 발권할 수 있나요?',
        a11: `2025년 3월 2일 이후, 티켓 리뉴얼에 따라 현지에서의 발권 절차는 불필요합니다.
당일에는 바우처 상의 링크를 클릭하고 화면에 표시된 QR코드를 입구에 제시하시면 바로 입장하실 수 있습니다.

*QR코드는 주식회사 덴소웨이브의 등록상표입니다.`,
        q12: '일찍 도착하면 예약한 시간보다 먼저 입장할 수 있나요?',
        a12: `예약하신 시간 이전에는 입장하실 수 없습니다.
구매 시 지정하신 시간대에 입장해 주시기 바랍니다.`,
        q13: '재입장이 가능한가요?',
        a13: `한 번 전망대에서 퇴장하신 후에는 재입장이 불가합니다.`
      },
      email: {
        title: '예약 완료 메일이 도착하지 않는 경우',
        q1: '예약 완료 메일이 도착하지 않습니다.',
        a1: `예약 시 등록하신 이메일 주소로 「예약이 확정 처리 되었습니다（예약 번호: ARS_SKYTREE-XXXX-XXXX）」라는 제목의 자동 메일을 발송하고 있으니 확인해 주시기 바랍니다.
・예약 확정 메일은 「@linktivity.co.jp」 도메인에서 발송됩니다.
・스팸 메일함 및 휴지통 폴더도 확인해 주시기 바랍니다.
・평소 자주 사용하지 않는 이메일 주소로 등록하셨을 가능성이 있습니다.
다른 가능성이 있는 이메일 주소의 수신함도 함께 확인해 주시기 바랍니다.

메일을 찾을 수 없는 경우에는 마이페이지에 로그인하여 예약 현황을 확인해 주시기 바랍니다.
▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

＊도쿄 스카이트리 공식 사이트 이외의 온라인 여행사에서 구매하신 경우에는 구매하신 여행사로 문의해 주시기 바랍니다.

▼ 로그인할 수 없는 경우
FAQ의 「계정에 로그인할 수 없을 때 어떻게 해야 하나요?」 항목을 참고해 주시기 바랍니다.`
      },
      use: {
        title: '티켓 이용・표시 방법',
        q1: '결제가 완료되었는데, 티켓을 찾을 수 없습니다.',
        a1: `당일 필요한 티켓 QR코드가 포함된 바우처는 마이페이지 또는 예약 확정 메일에서 확인하실 수 있습니다.

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

▼예약 확정 메일에 대하여
・예약 확정 메일은 「@linktivity.co.jp」 도메인에서 발송됩니다.
・스팸 메일함 및 휴지통 폴더도 확인해 주시기 바랍니다.
・평소 자주 사용하지 않는 이메일 주소로 등록하셨을 가능성이 있습니다.
다른 가능성이 있는 이메일 주소의 수신함도 함께 확인해 주시기 바랍니다.

메일을 찾을 수 없는 경우에는 마이페이지에 로그인하여 예약 현황을 확인해 주시기 바랍니다.
▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

＊도쿄 스카이트리 공식 사이트 이외의 온라인 여행사에서 구매하신 경우에는 구매하신 여행사로 문의해 주시기 바랍니다.`,
        q2: 'QR코드가 스마트폰 화면에 표시되지 않습니다.',
        a2: `당일 필요한 티켓 QR코드가 포함된 바우처는 마이페이지 또는 예약 확정 메일에서 확인하실 수 있습니다.

모바일 기기 화면에서 QR코드가 제대로 표시되지 않는 경우에는, 한 번 화면을 닫고, 인터넷 접속 상태가 좋은 곳에서 다시 시도해 주시기 바랍니다.
입장에는 QR코드가 필요하므로, 사전에 화면에 표시되는지 확인하시고 스크린샷을 촬영해 두시는 것도 권장드립니다.

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

▼ 로그인할 수 없는 경우
FAQ의 「로그인할 수 없습니다.」 항목을 참고해 주시기 바랍니다.

＊도쿄 스카이트리 공식 사이트 이외의 온라인 여행사에서 구매하신 경우에는 구매하신 여행사로 문의해 주시기 바랍니다.`,
        q3: '로그인할 수 없습니다.',
        a3: `1）먼저, 올바른 이메일 주소로 로그인하고 있는지 확인해 주시기 바랍니다.
평소 자주 사용하지 않는 이메일 주소로 등록하셨을 가능성이 있으므로, 가능성이 있는 다른 이메일 주소로도 로그인을 시도해 주시기 바랍니다.

2）신규 회원 등록 시와 동일한 로그인 방법을 이용해 주시기 바랍니다.
Gmail을 이용하시는 경우에는 신규 등록 시 「Google」 버튼을 통해 Google 연동을 선택하여 등록했는지, 또는 「이메일」 버튼을 통해 직접 이메일 주소를 입력하여 등록했는지 확인해 주시기 바랍니다.
비밀번호를 잊으신 경우에는 로그인 화면의 「비밀번호를 잊으신 경우」에서 비밀번호 재설정을 진행해 주시기 바랍니다.

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

＊도쿄 스카이트리 공식 사이트 이외의 온라인 여행사에서 구매하신 경우에는 구매하신 여행사로 문의해 주시기 바랍니다.`,
        q4: '예약 완료 메일을 삭제했습니다. 어떻게 해야 하나요?',
        a4: `다음 중 하나의 방법으로 바우처・QR코드를 표시하실 수 있습니다.

1）마이페이지에서 예약 확인
로그인 → 오른쪽 상단 사람 모양 아이콘  「마이페이지」 → 「예약 정보」 → 예약 목록 표시 → 예약 상세 화면에서 바우처 표시

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

2）마이페이지에서 메일 재발송
로그인 → 오른쪽 상단 사람 모양 아이콘 「마이페이지」 → 「예약 정보」 → 예약 목록 표시 → 예약 상세 화면의 「바우처 보내기」 버튼을 통해 원하는 주소로 티켓 URL이 포함된 바우처 재발송

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

＊도쿄 스카이트리 공식 사이트 이외의 온라인 여행사에서 구매하신 경우에는 구매하신 여행사로 문의해 주시기 바랍니다.`,
        q5: '계정을 삭제하여 마이페이지에 로그인할 수 없습니다. 티켓은 이용할 수 있나요?',
        a5: `예약을 취소하지 않은 한, 예약（티켓） 자체는 유효하므로 이용하실 수 있습니다.
예약 확정 메일에서 티켓 URL이 포함된 바우처를 표시하실 수 있습니다.

*QR코드는 주식회사 덴소웨이브의 등록상표입니다.`,
        q6: '바우처를 인쇄하여 지참해도 되나요?',
        a6: `QR코드는 종이에 출력한 것도 이용하실 수 있습니다. 스크린샷, 모바일 기기 화면 표시로도 이용하실 수 있습니다.
인쇄하실 경우에는 QR코드가 선명하게 출력된 것을 지참해 주시기 바랍니다.`,
        q7: '전망대 입장 후 체류 시간 제한이 있나요?',
        a7: `입장 후에는 체류 시간에 제한이 없습니다.`,
        q8: '사전에 발권할 수 있나요?',
        a8: `2026년 3월 2일 이후, 티켓 리뉴얼에 따라 현지에서의 발권 절차는 불필요합니다.
당일에는 바우처 상의 링크를 클릭하고 화면에 표시된 QR코드를 입구에 제시하시면 바로 입장하실 수 있습니다.`,
        q9: '일찍 도착하면 예약한 시간보다 먼저 입장할 수 있나요?',
        a9: `예약하신 시간 이전에는 입장하실 수 없습니다.
구매 시 지정하신 시간대에 입장해 주시기 바랍니다.`,
        q10: '재입장이 가능한가요?',
        a10: `한 번 전망대에서 퇴장하신 후에는 재입장이 불가합니다.`
      },
      changes: {
        title: '변경・취소',
        q1: '입장일・입장시간・인원 수의 변경은 가능한가요?',
        a1: `죄송하지만, 지정하신 입장일, 입장 시간, 인원 수의 변경은 불가합니다.
변경을 원하시는 경우에는 현재 예약을 한 번 취소하신 후, 다시 원하시는 내용으로 구매해 주시기 바랍니다.
・예약 시간에 늦을 것 같은 경우에는 지정일 당일에 한하여 안내 중인 줄의 마지막에서 입장이 가능합니다. 순차적으로 안내되나, 혼잡 상황에 따라 대기 시간이 발생할 수 있습니다.
・취소 시에는 취소 정책에 따라 규정된 취소 수수료가 발생합니다. 마이페이지에서 취소 정책 및 취소 수수료를 확인하신 후 진행해 주시기 바랍니다.
・부득이 전화나 이메일을 통한 취소는 접수하지 않습니다. 미리 양해 부탁드립니다.

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

*도쿄 스카이트리 공식 사이트가 아닌 다른 온라인 여행사를 통해 티켓을 구매하신 경우, 취소 정책은 공식 사이트와 다를 수 있습니다.
예약 시 해당 플랫폼에서 안내된 취소 조건을 확인하시고, 이용하신 여행사의 고객 지원팀으로 문의해 주시기 바랍니다.`,
        q2: '전망데크 입장권을 전망회랑과의 세트권으로 변경할 수 있나요?',
        a2: `・죄송하지만, 한 번 구매하신 후에는 전망회랑 세트권으로의 변경은 불가합니다.
・전망회랑 입장 티켓은 지상 350m 전망데크의 매표기에서 당일 구매하실 수 있습니다. 다만, 전망회랑의 혼잡 상황에 따라 판매를 중단하는 경우가 있습니다. 미리 양해 부탁드립니다.`,
        q3: '취소는 가능한가요?',
        a3: `・티켓 종류에 따라 취소 정책이 다릅니다. 취소를 원하시는 경우에는 마이페이지에서 취소 정책 및 취소 수수료를 확인하신 후 진행해 주시기 바랍니다.
・취소 시에는 규정된 취소 수수료가 발생합니다.
・부득이 전화나 이메일을 통한 취소는 접수하지 않습니다. 미리 양해 부탁드립니다.

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking
*도쿄 스카이트리 공식 사이트가 아닌 다른 온라인 여행사를 통해 티켓을 구매하신 경우, 취소 정책은 공식 사이트와 다를 수 있습니다.
예약 시 해당 플랫폼에서 안내된 취소 조건을 확인하시고, 이용하신 여행사의 고객 지원팀으로 문의해 주시기 바랍니다.`,
        q4: '엔조이팩에 포함된 일부시설을 이용하지 않았습니다. 환불이 가능한가요?',
        a4: `고객 사정으로 일부 시설을 이용하지 않으시는 경우, 환불은 불가합니다.`,
        q5: '티켓 종류나 날짜를 잘못 구매했습니다.',
        a5: `・죄송하지만, 티켓 종류, 날짜, 인원수 등을 잘못 구매하신 경우 변경은 불가합니다.
현재 예약을 한 번 취소하신 후, 다시 원하시는 내용으로 구매해 주시기 바랍니다.
・취소 시에는 마이페이지에서 취소 정책 및 취소 수수료를 확인하신 후 진행해 주시기 바랍니다.
・취소 정책에 따라 규정된 취소 수수료가 발생합니다.
・부득이 전화나 이메일을 통한 취소는 접수하지 않습니다. 미리 양해 부탁드립니다.

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking
*도쿄 스카이트리 공식 사이트가 아닌 다른 온라인 여행사를 통해 티켓을 구매하신 경우, 취소 정책은 공식 사이트와 다를 수 있습니다.
예약 시 해당 플랫폼에서 안내된 취소 조건을 확인하시고, 이용하신 여행사의 고객 지원팀으로 문의해 주시기 바랍니다.`,
        q6: '재해나 교통기관의 운휴・결항, 전염병으로 인해 방문이 어려운 경우 취소할 수 있나요?',
        a6: `・임시 휴관의 경우를 제외하고는 특별 취소는 접수하지 않습니다.
임시 휴관의 경우에는 도쿄 스카이트리 공식 사이트에 공지됩니다.
・교통기관의 지연 및 운휴 등으로 취소를 원하시는 경우에는 마이페이지에서 취소 정책 및 취소 수수료를 확인하신 후 직접 취소 진행해 주시기 바랍니다.
・부득이 유선상으로 취소는 접수하지 않습니다. 미리 양해 부탁드립니다.

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking
▼도쿄 스카이트리 공식 사이트
https://www.tokyo-skytree.jp/kr/
*도쿄 스카이트리 공식 사이트가 아닌 다른 온라인 여행사를 통해 티켓을 구매하신 경우, 취소 정책은 공식 사이트와 다를 수 있습니다.
예약 시 해당 플랫폼에서 안내된 취소 조건을 확인하시고, 이용하신 여행사의 고객 지원팀으로 문의해 주시기 바랍니다.`,
        q7: '강풍으로 인해 엘리베이터 운행이 중단된 경우 환불되나요?',
        a7: `・고객의 안전을 고려하여, 상공의 기상 악화나 강풍으로 인해 전망대행 엘리베이터 운행이 일시 중단될 수 있습니다.
최신 정보는 도쿄 스카이트리 공식 사이트에서 확인해 주시기 바랍니다.
운행 재개 예정 및 환불에 대해서는 우선 현지 직원에게 상담해 주시기 바랍니다.

▼도쿄 스카이트리 공식 사이트
https://www.tokyo-skytree.jp/kr/`
      },
      payment: {
        title: '결제・각종 할인',
        q1: '카드에서 이중으로 인출된 것 같습니다.',
        a1: `・먼저, 마이페이지에서 예약 현황을 확인해 주시기 바랍니다.
예약이 1건만 표시되는 경우, 다른 한 건의 결제는 이용 알림만 도착한 상태이며 실제 인출은 이루어지지 않았을 가능성이 있습니다.

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

・결제 현황에 대해 자세한 확인을 원하시는 경우에는 아래 양식을 통해 문의해 주시기 바랍니다.
https://veltra.zendesk.com/hc/ko/requests/new?ticket_form_id=53455569113241`,
        q2: '결제가 실패로 표시되었습니다. 어떻게 해야 하나요?',
        a2: `・먼저 마이페이지에서 예약이 완료되었는지 확인해 주시기 바랍니다.
예약 정보가 표시되지 않는 경우, 예약이 완료되지 않은 상태입니다.
아래 내용을 확인하신 후 다시 한 번 구매 절차를 진행해 주시기 바랍니다.

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

자주 발생하는 원인：

1）통신 상태
・일시적인 통신 환경 악화 또는 동일 시간대에 다수의 예약이 집중되어 네트워크・결제가 중단되었을 가능성이 있습니다.
번거로우시겠지만 한 번 화면을 닫고, 잠시 후 전파 상태가 좋은 곳에서 처음부터 다시 결제를 시도해 주시기 바랍니다.

2）카드 이용 상태・3D Secure 관련
・소지하신 신용카드의 유효기간, 이용 한도에 문제가 없는지 확인해 주시기 바랍니다.
・소지하신 신용카드가 「3D Secure」에 대응하고 있는지 확인해 주시기 바랍니다.
2025년 4월부터 온라인 구매 시 신용카드 「3D Secure」 도입이 의무화됨에 따라,
도쿄 스카이트리 예약 사이트에서는 「3D Secure」가 설정된 카드만 결제가 가능합니다.

3）카드사 보안 시스템 작동
카드에 문제가 없음에도 결제가 되지 않는 경우, 카드사의 보안 시스템이 작동하여 결제가 중단되었을 가능성이 있습니다.
잠시 후 다른 카드로 다시 시도하시거나, 이용 중인 카드사에 문의해 주시기 바랍니다.

・결제 현황에 대해 자세한 확인을 원하시는 경우에는 아래 양식을 통해 문의해 주시기 바랍니다.
https://veltra.zendesk.com/hc/ko/requests/new?ticket_form_id=53455569113241`,
        q3: '카드사로부터 이용 알림이 왔지만, 마이페이지에 예약 정보가 없고 예약 확정 메일도 오지 않습니다.',
        a3: `아래 중 하나의 상황이 해당될 수 있습니다.

1) 평소 자주 사용하지 않는 이메일 주소로 등록한 경우
다른 가능성이 있는 이메일 주소의 수신함과 스팸 메일함을 확인해 주시기 바랍니다.
마이페이지 로그인도 시도해 주시기 바랍니다.

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking

2) Google 메일을 이용 중이며 로그인 방법이 다른 경우
예약(신규 등록) 시 선택한 방법과 동일한 조건으로 로그인해 주시기 바랍니다.
・예약 시 「Email 로그인」을 선택한 경우에는 「Email 로그인」을 이용
・예약 시 「Google 로그인」을 선택한 경우에는 「Google 로그인」을 이용

3) 결제와 예약이 완료되지 않은 경우
카드 한도 확보 단계까지는 진행되었으나, 일시적인 통신 환경 악화 등으로 인해 결제와 예약이 완료되지 않았을 가능성이 있습니다.
카드 명세서에 기재되어 있는지 확인해 주시기 바랍니다.

결제 및 예약 현황에 대해 자세한 확인을 원하시는 경우에는 아래 양식을 통해 문의해 주시기 바랍니다.
https://veltra.zendesk.com/hc/ko/requests/new?ticket_form_id=53455569113241`,
        q4: '취소했습니다. 환불은 언제 되나요?',
        a4: `・티켓 종류에 따라 취소 수수료가 다르므로, 먼저 마이페이지에서 취소 수수료를 확인해 주시기 바랍니다.
・환불 대상임에도 환불이 이루어지지 않은 경우, 카드사에서의 환불 절차에 시간이 소요되고 있을 가능성이 있습니다.
카드사에 한 번 확인해 주시기 바랍니다.
・환불 현황에 대해 자세한 확인을 원하시는 경우에는 아래 양식을 통해 문의해 주시기 바랍니다.
https://veltra.zendesk.com/hc/ko/requests/new?ticket_form_id=53455569113241`,
        q5: '영수증 발행이 가능한가요?',
        a5: `・도쿄 스카이트리 공식 사이트에서 구매한 경우：
영수증은 마이페이지 또는 예약 확정 메일의 「영수증」 버튼에서 직접 발행하실 수 있습니다.
발행 후에는 「linktivity.co.jp」 도메인에서 「영수증 발행 안내[Linktivity]」라는 제목의 메일로 발송됩니다.
혹시 모르니 스팸 메일함이나 휴지통 폴더도 확인해 주시기 바랍니다.

▼마이페이지 로그인
https://global-official-ticket.tokyo-skytree.jp/ko/booking`
      },
      disabilities: {
        title: '장애인 요금 적용 안내',
        q1: '장애인 요금 적용 안내',
        a1: `적용 조건에 대해

장애인 수첩을 소지한 분과 그 동반자 분에게 장애인 요금을 적용합니다.
동반자의 티켓은 장애인 수첩을 소지한 분과 동일한 수만큼 구매하실 수 있습니다.
입장 시 장애인 수첩을 확인하므로, 당일 제시해 주시기 바랍니다.


일반 요금에서 변경에 대해
일반 요금으로 티켓을 구매하신 경우,
장애인 요금으로의 변경은 불가합니다.
변경을 원하시는 경우,
현재 예약을 한 번 취소하신 후, 다시 원하시는 내용으로 구매해 주시기 바랍니다.
▼취소 방법은 아래에서 확인해 주시기 바랍니다
https://global-official-ticket.tokyo-skytree.jp/ko/booking`
      },
      group: {
        title: '단체 예약 안내',
        q1: '단체 예약 안내',
        a1: `・단체 예약은 도쿄 스카이트리 전용 창구에서 접수하고 있습니다.
도쿄 스카이트리 공식 사이트의 「문의」 페이지에서 「문의처 일람」을 확인해 주시기 바랍니다.

▼도쿄 스카이트리 공식 사이트 단체 예약 전용 창구
https://www.tokyo-skytree.jp/inquiry/`
      },
      tips: `이메일 문의 : <a href="mailto:helpcenter@linktivity.co.jp" rel="noreferrer">helpcenter@linktivity.co.jp</a>
온라인 구매 관련 전화 상담: <a href="tel:+81368217196">+81-3-6821-7196</a>
※ 전화 문의 시 먼저 자동 음성 안내가 제공되며, 문의 내용에 따라 상담원에게 연결됩니다.
※ 전화 상담의 경우, 통화 요금이 부과됩니다.
전화 상담원 연결 가능 시간: 10:00~19:00`
    }
  }
};
